import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "indesign-dom-apis"
    }}>{`InDesign DOM APIs`}</h1>
    <p>{`InDesign APIs (aka Document Object Model DOM or OMV) is used to create and modify the application document and content.`}</p>
    <InlineAlert variant="info" slots="text1, text2" mdxType="InlineAlert" />
    <p><strong parentName="p">{`Prior to v18.4`}</strong>{`, the InDesign DOM was available in the global space by default.`}</p>
    <p><strong parentName="p">{`Starting v18.4`}</strong>{`, InDesign DOM is available only as a JavaScript module and should be retrieved on a need basis using `}<inlineCode parentName="p">{`require()`}</inlineCode>{`.`}</p>
    <p>{`To access the InDesign DOM APIs from v18.4 onwards, use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myInDesign = require("indesign");
const app = myInDesign.app;
`}</code></pre>
    <h2 {...{
      "id": "dom-version"
    }}>{`DOM version`}</h2>
    <p>{`DOM versioning refers to the specific version of InDesign Document Object Model. By specifying a version, you can ensure that your script/plugin remains forward compatible, which means it will work with newer versions of InDesign, even if DOM has changed in subsequent releases. `}</p>
    <p>{`The available DOM versions as of today are `}<strong parentName="p">{`3.0, 4.0, 5.0, 6.0, 7.0, 7.5, 8.0, 9.0, 10.0, 10.1, 10.2, 11.0, 11.2, 11.3, 11.4, 12.0, 12.1, 13.0, 13.1, 14.0, 15.0, 15.1, 16.0, 16.1, 16.2, 17.0, 18.0`}</strong></p>
    <p>{`To know which version of DOM API your app is currently using, you can use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myInDesign = require("indesign");
const app = myInDesign.app;
console.log(app.scriptPreferences.version);
`}</code></pre>
    <p>{`To switch to a particular version of DOM API, use`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myInDesign = require("indesign-16.1");
`}</code></pre>
    <p>{`The above will make sure that going forward you will be using v16.1 DOM APIs. `}</p>
    <p><strong parentName="p">{`NOTE`}</strong>{` that if you retrieved a specific DOM version (let's assume 'A') and then did `}<inlineCode parentName="p">{`require("indesign")`}</inlineCode>{`, it will fetch the same DOM version 'A'. For example,`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const inDesignAppV17 = require("indesign-17.0").app;
const inDesignApp = require("indesign").app;

console.log(\`Versions: \${inDesignAppV17.scriptPreferences.version} and \${inDesignApp.scriptPreferences.version} will be v17.0\`);
`}</code></pre>
    <p>{`Also note that you cannot work with two different DOM versions at the same time. `}<inlineCode parentName="p">{`require("indesign");`}</inlineCode>{` assumes that there will be no further change in the DOM version. In the below example, the object `}<inlineCode parentName="p">{`inDesignV17`}</inlineCode>{` will be 'undefined'.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const inDesign = require("indesign");
const inDesignV17 = require("indesign-17.0");
`}</code></pre>
    <p>{`Once you have the right DOM API version, use the `}<a parentName="p" {...{
        "href": "/indesign/uxp/indesign/dom/api/"
      }}>{`API reference`}</a>{` to access available objects, methods etc.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      